export const weddingImages = [
	{
        img: "/images/weddings/wedding-1.jpg",
	},
	{
		img: "/images/weddings/wedding-2.jpg",	
	},
	{
		img: "/images/weddings/wedding-3.jpg",
	},
	{
		img: "/images/weddings/wedding-4.jpg",
	},
	{
		img: "/images/weddings/wedding-5.jpg",
	},
	{
		img: "/images/weddings/wedding-6.jpg",
	},
	{
		img: "/images/weddings/wedding-7.jpg",
	},
	{
		img: "/images/weddings/wedding-8.jpg",
	},
	{
		img: "/images/weddings/wedding-9.jpg",
	},
	{
		img: "/images/weddings/wedding-10.jpg",
	},
	{
		img: "/images/weddings/wedding-11.jpg",
	},
	{
		img: "/images/weddings/wedding-12.jpg",	
	},
	{
		img: "/images/weddings/wedding-13.jpg",
	},
	{
		img: "/images/weddings/wedding-14.jpg",
	},
	{
		img: "/images/weddings/wedding-15.jpg",
	},
	{
		img: "/images/weddings/wedding-16.jpg",
	},
	{
		img: "/images/weddings/wedding-17.jpg",	
	},
	{
		img: "/images/weddings/wedding-18.jpg",	
	},
	{
		img: "/images/weddings/wedding-19.jpg",
	},
	{
		img: "/images/weddings/wedding-20.jpg",
	},
	{
		img: "/images/weddings/wedding-21.jpg",
	},
	{
		img: "/images/weddings/wedding-22.jpg",	
	},
	{
		img: "/images/weddings/wedding-23.jpg",
	},
	{
		img: "/images/weddings/wedding-24.jpg",	
	},
	{
		img: "/images/weddings/wedding-25.jpg",	
	},
	{
		img: "/images/weddings/wedding-26.jpg",
	},
	{
		img: "/images/weddings/wedding-27.jpg",	
	},
	{
		img: "/images/weddings/wedding-28.jpg",	
	},
	{
		img: "/images/weddings/wedding-29.jpg",	
	},
	{
		img: "/images/weddings/wedding-30.jpg",
	},
	{
		img: "/images/weddings/wedding-31.jpg",
	},
	{
		img: "/images/weddings/wedding-32.jpg",
	}
]

export const preweddingImages = [
	{
		img: "/images/pre-weddings/prewedding-1.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-2.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-3.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-4.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-5.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-6.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-7.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-8.jpg",     
	},
	{
		img: "/images/pre-weddings/prewedding-9.jpg",     
	},
	{
		img: "/images/pre-weddings/prewedding-10.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-11.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-12.jpg",     
	},
	{
		img: "/images/pre-weddings/prewedding-13.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-14.jpg",     
	},
	{
		img: "/images/pre-weddings/prewedding-15.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-16.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-17.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-18.jpg",       
	},
	{
		img: "/images/pre-weddings/prewedding-19.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-20.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-21.jpg",       
	},
	{
		img: "/images/pre-weddings/prewedding-22.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-23.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-24.jpg",       
	},
	{
		img: "/images/pre-weddings/prewedding-25.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-26.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-27.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-28.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-29.jpg",      
	},
	{
		img: "/images/pre-weddings/prewedding-30.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-31.jpg",
	},
	{
		img: "/images/pre-weddings/prewedding-32.jpg",
	}
]